import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { GestionnaireGuard } from '../core/guards/gestionnaire.guard';
import { FamilleGuard } from '../core/guards/famille.guard';
import { RoleGuard } from '../core/guards/role.guard';
import { ROLES } from '../core/constants/roles.constants';

export const DOCUMENTS_ROUTES: Routes = [
  {
    path: 'documents/list',
    loadComponent: () => import('../features/documents/list/list.component').then(m => m.DocumentsListComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'documents-officiels/list',
    loadComponent: () =>
      import('../features/documents-officiels/list/list.component').then(m => m.OfficialDocumentsListComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [
        ROLES.ADMIN,
        ROLES.SUPERADMIN,
        ROLES.EHPAD,
        ROLES.PRATICIEN,
        ROLES.ANIMATEUR,
        ROLES.TECH,
        ROLES.PODOLOGUE,
        ROLES.COIFFEUR,
        ROLES.KINE,
        ROLES.FAMILLE,
      ],
    },
  },
  {
    path: 'documents/famille',
    loadComponent: () =>
      import('../features/documents/famille/liste-document-famille.component').then(m => m.ListeDocumentFamilleComponent),
    canActivate: [AuthGuard, FamilleGuard],
  },
  {
    path: 'documents/externe',
    loadComponent: () =>
      import('../features/documents/externe/liste-document-externe.component').then(m => m.ListeDocumentExterneComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.PODOLOGUE, ROLES.COIFFEUR],
    },
  },
  {
    path: 'documents/personnel/shared',
    loadComponent: () =>
      import('../features/documents/personnel/personnel-shared-documents.component').then(
        m => m.PersonnelSharedDocumentsComponent
      ),
    canActivate: [AuthGuard],
  },
];
